import { render, staticRenderFns } from "./SectionAutocomplete.vue?vue&type=template&id=2028d402&scoped=true"
import script from "./SectionAutocomplete.vue?vue&type=script&lang=js"
export * from "./SectionAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028d402",
  null
  
)

export default component.exports